import { location_addressService } from '../_services';

const state = { onRequest: false, location_address: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        location_addressService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  location_address: state => {
    return state.location_address
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.location_address = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.location_address = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.location_address = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const location_addresses = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
